export const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB
export const MAX_VIDEO_SIZE = 16 * 1024 * 1024; // 16MB
export const MAX_AUDIO_SIZE = 16 * 1024 * 1024;  // 16MB
export const MAX_DOCUMENT_SIZE = 10 * 1024 * 1024; // 10MB
export const MAX_DOCUMENT_SIZE_LABEL = '10MB';

export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png'];
export const ALLOWED_VIDEO_TYPES = ['video/mp4', 'video/3gpp'];
export const ALLOWED_DOCUMENT_TYPES = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/plain',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
];

// ---------------------------------------------------------------------------
// WhatsApp-supported media constants
// Source: https://developers.facebook.com/docs/whatsapp/cloud-api/reference/media
// ---------------------------------------------------------------------------

/** WhatsApp-supported audio MIME types (max 16 MB each) */
export const ALLOWED_AUDIO_MIME_TYPES = new Set([
  'audio/aac',
  'audio/amr',
  'audio/mpeg',   // .mp3
  'audio/mp4',    // .m4a
  'audio/ogg',    // .ogg — OPUS codec only
])


/** Max upload size in MB, keyed by media category */
export const MEDIA_SIZE_LIMITS: Record<string, number> = {
  image: MAX_IMAGE_SIZE / (1024 * 1024),
  video: MAX_VIDEO_SIZE / (1024 * 1024),
  audio: MAX_AUDIO_SIZE / (1024 * 1024),
  document: MAX_DOCUMENT_SIZE / (1024 * 1024),
}

/** accept string for the audio <input type="file"> */
export const AUDIO_ACCEPT =
  '.aac,.amr,.mp3,.m4a,.ogg,audio/aac,audio/amr,audio/mpeg,audio/mp4,audio/ogg'

/** accept string for the document <input type="file"> */
export const DOCUMENT_ACCEPT = [
  '.txt,.xls,.xlsx,.doc,.docx,.ppt,.pptx,.pdf',
  'text/plain',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/pdf',
].join(',')
